<main class="login-main">
  <div class="login-container">

    <!-- Left side - Carousel: slide 1 branding Atlas, slide 2 foto magazzino -->
    <div class="atlas-side" (mouseenter)="pauseCarousel()" (mouseleave)="resumeCarousel()">

      <!-- Slide 1: branding Atlas -->
      <div class="atlas-slide" [class.is-active]="activeSlide === 0" [attr.aria-hidden]="activeSlide !== 0">
        <div class="atlas-content">
          <img src="assets/img/atlas.webp" alt="Atlas" class="atlas-logo" />
          <h2 class="atlas-title">Atlas / Ἄτλας</h2>
          <p class="atlas-description">{{ 'LOGIN.ATLAS_DESCRIPTION' | translate }}</p>
        </div>
      </div>

      <!-- Slide 2: foto a tutto pannello -->
      <div class="atlas-slide atlas-slide--photo" [class.is-active]="activeSlide === 1" [attr.aria-hidden]="activeSlide !== 1">
        <img src="assets/img/sona.webp" alt="" class="atlas-photo" />
      </div>

      <!-- Slide 3: foto a tutto pannello -->
      <div class="atlas-slide atlas-slide--photo" [class.is-active]="activeSlide === 2" [attr.aria-hidden]="activeSlide !== 2">
        <img src="assets/img/moto.webp" alt="" class="atlas-photo" />
      </div>

      <!-- Slide 4: foto a tutto pannello -->
      <div class="atlas-slide atlas-slide--photo" [class.is-active]="activeSlide === 3" [attr.aria-hidden]="activeSlide !== 3">
        <img src="assets/img/sona2.webp" alt="" class="atlas-photo" />
      </div>

      <!-- Puntini di navigazione -->
      <div class="atlas-dots">
        <button
          *ngFor="let slide of slides; let i = index"
          type="button"
          class="atlas-dot"
          [class.is-active]="activeSlide === i"
          [attr.aria-label]="'Slide ' + (i + 1)"
          [attr.aria-current]="activeSlide === i ? 'true' : null"
          (click)="goToSlide(i)">
        </button>
      </div>
    </div>

    <!-- Right side - Login form -->
    <div class="login-side">
      <div class="login-content">

        <div class="login-heading">
          <div class="login-heading-icon"><i class="fas fa-right-to-bracket"></i></div>
          <div>
            <h1 class="login-title">{{ 'LOGIN.TITLE' | translate }}</h1>
            <p class="login-subtitle">{{ 'LOGIN.SUBTITLE' | translate }}</p>
          </div>
        </div>

        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">

          <!-- Messaggio di errore generale del form -->
          <div *ngIf="hasGeneralError() && showGeneralError" class="login-alert login-alert--error">
            <i class="fa fa-exclamation-triangle"></i>
            <span>{{ getGeneralError() | translate }}</span>
          </div>

          <!-- Email -->
          <label class="login-label" for="email">{{ 'LOGIN.EMAIL_LABEL' | translate }}</label>
          <div class="login-input-wrapper" [class.is-invalid]="hasError('email')">
            <i class="fas fa-envelope login-input-icon"></i>
            <input
              id="email"
              type="email"
              formControlName="email"
              class="login-input"
              [placeholder]="'LOGIN.EMAIL_PLACEHOLDER' | translate"
              (input)="onInputChange()"
              autocomplete="email"
            />
          </div>
          <div *ngIf="hasError('email')" class="login-error">
            <i class="fas fa-exclamation-circle"></i>
            {{ getErrorMessage('email') | translate }}
          </div>

          <!-- Password -->
          <label class="login-label login-label--spaced" for="password">{{ 'LOGIN.PASSWORD_LABEL' | translate }}</label>
          <div class="login-input-wrapper" [class.is-invalid]="hasError('password')">
            <i class="fas fa-lock login-input-icon"></i>
            <input
              id="password"
              [type]="showPassword ? 'text' : 'password'"
              formControlName="password"
              class="login-input"
              [placeholder]="'LOGIN.PASSWORD_PLACEHOLDER' | translate"
              (input)="onInputChange()"
              autocomplete="current-password"
            />
            <button type="button" class="login-eye-btn" (click)="showPassword = !showPassword" tabindex="-1"
                    [title]="showPassword ? 'Nascondi password' : 'Mostra password'">
              <i class="fa" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
            </button>
          </div>
          <div *ngIf="hasError('password')" class="login-error">
            <i class="fas fa-exclamation-circle"></i>
            {{ getErrorMessage('password') | translate }}
          </div>

          <!-- Submit -->
          <button type="submit" class="login-btn" [disabled]="isLoading">
            <ng-container *ngIf="!isLoading">
              {{ 'LOGIN.BUTTON' | translate }}
              <i class="fas fa-arrow-right"></i>
            </ng-container>
            <ng-container *ngIf="isLoading">
              <i class="fa-solid fa-truck-fast truck-animation"></i>
            </ng-container>
          </button>

          <div class="form-footer-register">
            {{ 'LOGIN.REGISTER_QUESTION' | translate }}
            <a href="/registration">{{ 'LOGIN.REGISTER' | translate }}</a>
          </div>

          <!-- Footer -->
          <div class="login-footer">
            <a routerLink="/recovery">
              <i class="fas fa-unlock-alt"></i>
              {{ 'LOGIN.RECOVERY' | translate }}
            </a>
          </div>
        </form>

      </div>
    </div>

  </div>
</main>
